import React from "react";
import Whatsapp from "views/presentation-sections/Whatsapp.js";
import GenesysMessenger from "components/GenesysMessenger/GenesysMessenger.js";
import "assets/demo/iconosFlotantes.css";

function FloatingContactStack() {
  return (
    <div className="floating-contact-stack">
      <Whatsapp />
      <GenesysMessenger />
    </div>
  );
}

export default FloatingContactStack;
